import { trackEvent } from "../../helpers/analyticsHelpers";
import { Cuepoint } from "../../types/player-api";

export const skipSegment = (
  programId: string,
  onSeekTo: (seek: number) => void,
  duration?: number,
  cuepoint?: Cuepoint
): void => {
  trackEvent(`player.skip.${cuepoint?.kind}`, {
    programId
  });
  if (cuepoint?.end_time) {
    onSeekTo(cuepoint.end_time);
  } else if (duration) {
    onSeekTo(duration);
  }
};
